export default "__VITE_ASSET__BrdMMUoH__"